/**
 * Reset stage input fields error class once user has changed input field. Also manipulates data-gtm-event-label if [name="type"] is present
 */

const init = function() {
  const stageFormElements = document.getElementsByClassName('stage-form');

  if(stageFormElements.length) {
    for (let i = 0; i < stageFormElements.length; i++) {
      stageFormElements[i].addEventListener('change', e => {
        e.target.classList.remove('stage-error');
      });

      const subjectInput = stageFormElements[i].querySelector('[name="type"]') || false;

      if (subjectInput && 'gtmEventLabel' in stageFormElements[i].dataset) {
        subjectInput.addEventListener('change', function(e) {
          stageFormElements[i].dataset.gtmEventLabel = this.value;
        });
      }
      stageFormElements[i].dataset.gtmEventLabel = subjectInput.value;
    }
  }
}

export default {
  init: init
}
